
"use client";

import React from "react";
import Link from "next/link";
import Image from "next/image";
import styles from "../styles/components/Footer.module.scss";

import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";

import TripAdvisorWidget from "./TripAdvisorWidget";
import { usePathname } from "next/navigation";

function Footer() {
  const pathname = usePathname();

  /*
   * App Router replacement for:
   *
   * const router = useRouter();
   * router.pathname
   */

  const searchResult = pathname === "/searchresult";

  const checkout =
    pathname === "/searchresult/checkout";

  /*
   * Contact information
   */

  const contact = [
    // {
    //   title: "+91 9317192605",
    //   hyperLink: "tel:9317192605",
    //   icon: "/icons/call-gray.svg",
    // },

    {
      title:
        "NH 05, New kufri, Galu, Hills, Shimla, Himachal Pradesh, India 171209",
      hyperLink:
        "https://g.page/hotel-the-twin-towers-new-kufri",
      icon: "/icons/map-gray.svg",
    },

    {
      title: "info@hoteltwintowers.com",
      hyperLink:
        "mailto:info@hoteltwintowers.com",
      icon: "/icons/mail-gray.svg",
    },
  ];

  /*
   * Quick links
   */

  const quick_links = [
    {
      title: "About us",
      hyperLink: "/about-us",
    },
    {
      title: "Blogs",
      hyperLink: "/blogs",
    },
    {
      title: "Contact us",
      hyperLink: "/contact-us",
    },
    {
      title: "Restaurant & Bar",
      hyperLink: "/bar-and-restaurant",
    },
    {
      title: "Rooms & Suites",
      hyperLink: "/hotel-room-in-shimla",
    },
    {
      title: "Banquet Halls in Shimla",
      hyperLink: "/banquet-halls-in-shimla",
    },
    {
      title: "Conference Hall",
      hyperLink: "/conference-hall",
    },
    {
      title: "Gallery",
      hyperLink: "/gallery",
    },
  ];

  /*
   * Legal links
   */

  const casestudies = [
    {
      title: "Cancellation & Refund Policy",
      hyperLink:
        "/cancellation-and-refundpolicies",
    },
    {
      title: "COVID Policy",
      hyperLink: "/covid-policy",
    },
    {
      title: "Privacy Policy",
      hyperLink: "/privacy-policy",
    },
    {
      title: "Terms & Conditions",
      hyperLink: "/terms-and-conditions",
    },
  ];

  /*
   * Current year
   */

  const currentYear =
    new Date().getFullYear();

  return (
    <footer
      className={`${styles.footer_sec} footer_scroll`}
      data-speed="1"
    >
      <div className="container">
        {/* =========================
            FOOTER UPPER
        ========================== */}

        <div
          className={`${styles.footer_upper} row`}
        >
          {/* =========================
              LOGO + SOCIAL MEDIA
          ========================== */}

          <div
            className={`${styles.footer_column} col`}
          >
            <ul>
              <li
                className={
                  styles.footer_social
                }
              >
                {/* Logo */}

                <Link href="/">
                  <Image
                    src="/icons/footer-logo.svg"
                    height={150}
                    width={250}
                    alt="The Twin Towers Hotel Footer Logo"
                    loading="eager"
                  />
                </Link>

                {/* Social links */}

                <div
                  className={
                    styles.footer_social_links
                  }
                >
                  {/* Facebook */}

                  <div
                    className={styles.icon}
                  >
                    <Link
                      className={styles.fb}
                      href="https://www.facebook.com/twintower.hotel"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebookF />
                    </Link>
                  </div>

                  {/* Instagram */}

                  <div
                    className={styles.icon}
                  >
                    <Link
                      href="https://www.instagram.com/hotel_twintowers"
                      className={styles.insta}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram />
                    </Link>
                  </div>

                  {/* LinkedIn */}

                  <div
                    className={styles.icon}
                  >
                    <Link
                      className={
                        styles.linkedin
                      }
                      href="https://www.linkedin.com/in/the-twin-towers-hotel"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaLinkedinIn />
                    </Link>
                  </div>

                  {/* YouTube */}

                  <div
                    className={styles.icon}
                  >
                    <Link
                      href="https://www.youtube.com/@thetwintowershotel"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaYoutube />
                    </Link>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          {/* =========================
              QUICK LINKS
          ========================== */}

          <div
            className={`${styles.footer_column} col`}
          >
            <p>Quick Links</p>

            <ul>
              {quick_links.map(
                (item, index) => (
                  <li key={index}>
                    <Link
                      href={item.hyperLink}
                    >
                      {item.title}
                    </Link>
                  </li>
                )
              )}
            </ul>
          </div>

          {/* =========================
              LEGAL
          ========================== */}

          <div
            className={`${styles.footer_column} col`}
          >
            <p>Legal</p>

            <ul>
              {casestudies.map(
                (item, index) => (
                  <li key={index}>
                    <Link
                      href={item.hyperLink}
                    >
                      {item.title}
                    </Link>
                  </li>
                )
              )}

              {/* RSS */}

              <li>
                <Link
                  href="/rss.xml"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  RSS
                </Link>
              </li>
            </ul>
          </div>

          {/* =========================
              CONTACT US
          ========================== */}

          <div
            className={`${styles.footer_column} col`}
          >
            <p>Contact Us</p>

            <ul>
              {/* Phone numbers */}

              <li
                className={
                  styles.contect_info
                }
              >
                <Image
                  src="/icons/call-gray.svg"
                  width={18}
                  height={18}
                  className={`${styles.footer_icon} mt-2`}
                  alt="Reservation"
                />

                <div>
                  <Link href="tel:9318192605">
                    +91 93181-92605
                  </Link>

                  <br />

                  <Link href="tel:9317192601">
                    +91 93171-92601
                  </Link>

                  <br />

                  <Link href="tel:9318192601">
                    +91 93181-92601
                  </Link>
                </div>
              </li>

              {/* Address + Email */}

              {contact.map(
                (item, index) => (
                  <li key={index}>
                    <Link
                      href={item.hyperLink}
                    >
                      <span>
                        <Image
                          src={item.icon}
                          width={18}
                          height={18}
                          className={
                            styles.footer_icon
                          }
                          alt="Contact information"
                        />
                      </span>

                      <p>
                        {item.title}
                      </p>
                    </Link>
                  </li>
                )
              )}
            </ul>
          </div>

          {/* =========================
              TRIPADVISOR
          ========================== */}

          <div
            className={`${styles.footer_column} col ${styles.footer_tripAdv}`}
          >
            <TripAdvisorWidget />
          </div>
        </div>

        {/* =========================
            FOOTER BOTTOM
        ========================== */}

        <div
          className={
            styles.footer_bottom
          }
        >
          {/* Copyright */}

          <div
            className={
              styles.footer_bottom_left
            }
          >
            <p>
              &#169; {currentYear} The Twin
              Towers Hotel. All Rights
              Reserved
            </p>
          </div>

          {/* Powered By */}

          <div
            className={
              styles.footer_bottom_right
            }
          >
            <p>
              <span
                className={
                  styles.footer_p
                }
              >
                Powered By:
              </span>

              <Link
                href="https://unmeteredtechnologies.com/"
                target="_blank"
                rel="nofollow noopener noreferrer"
              >
                <Image
                  src={
                    searchResult || checkout
                      ? "/icons/rev-gif.gif"
                      : "/icons/unmetered-logo.gif"
                  }
                  width={79}
                  height={16}
                  alt="Company logo"
                  unoptimized
                />
              </Link>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
